import { ICommandBase } from "@Reports/cqrs";
import { PortfolioBalancerReportSettings } from "@Reports/Model";

export class DeleteReportCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Reports.Reports.Commands.DeleteReportCommandV1, TCh.Domain.Reports';

	Id: string;
	WorkspaceId: number;

	constructor(workspaceId: number, reportId: string)
	{
		this.Id = reportId;
		this.WorkspaceId = workspaceId;
	}

	static matchType(cmd: ICommandBase)	{
		return cmd.$type == 'TCh.Domain.Reports.Reports.Commands.DeleteReportCommandV1, TCh.Domain.Reports'
	}
}

export class CreateReportCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Reports.Reports.Commands.CreateReportCommandV1, TCh.Domain.Reports';

	WorkspaceId: number;
	ProjectId: number;
	Id: string;
	Name: string;
	Description: string;

	constructor(workspaceId: number, projectId: number, reportId: string, name: string, description: string)
	{
		this.WorkspaceId = workspaceId;
		this.ProjectId = projectId;
		this.Id = reportId;
		this.Name = name;
		this.Description = description;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Reports.Reports.Commands.CreateReportCommandV1, TCh.Domain.Reports'
	}
}


export class CloneReportCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Reports.Reports.Commands.CloneReportCommandV1, TCh.Domain.Reports';

	Id: string;
	WorkspaceId: number;
	SourceId: string;

	constructor(workspaceId: number, reportId: string, sourceId: string)
	{
		this.Id = reportId;
		this.WorkspaceId = workspaceId;
		this.SourceId = sourceId;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Reports.Reports.Commands.CloneReportCommandV1, TCh.Domain.Reports'
	}
}

export class UpdateReportCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Reports.Reports.Commands.UpdateReportCommandV1, TCh.Domain.Reports';

	Id: string;
	WorkspaceId: number;
	Name: string;
	Description: string;

	constructor(workspaceId: number, reportId: string, name: string, description: string)
	{
		this.Id = reportId;
		this.WorkspaceId = workspaceId;
		this.Name = name;
		this.Description = description;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Reports.Reports.Commands.UpdateReportCommandV1, TCh.Domain.Reports'
	}
}

export class UpdatePortfolioBalancerReportCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Reports.Reports.Commands.UpdatePortfolioBalancerReportCommandV1, TCh.Domain.Reports';

	WorkspaceId: number;
	ProjectId: number;
	Id: string;
	Settings: PortfolioBalancerReportSettings;

	constructor(workspaceId: number, projectId: number, reportId: string, settings: PortfolioBalancerReportSettings)
	{
		this.WorkspaceId = workspaceId;
		this.ProjectId = projectId;
		this.Id = reportId;
		this.Settings = settings;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Reports.Reports.Commands.UpdatePortfolioBalancerReportCommandV1, TCh.Domain.Reports'
	}
}